import { render, staticRenderFns } from "./favoriteApp.vue?vue&type=template&id=1c43e667&"
import script from "./favoriteApp.vue?vue&type=script&lang=js&"
export * from "./favoriteApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports